/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { PaginatedTeacherTargetList } from '../model/paginatedTeacherTargetList';
import { PatchedTeacherTarget } from '../model/patchedTeacherTarget';
import { TeacherTarget } from '../model/teacherTarget';
import { TeacherTargetCreate } from '../model/teacherTargetCreate';
import { TeacherTargetUpdate } from '../model/teacherTargetUpdate';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class TeacherTargetService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * Ordering options: fulfillment_date, created, modified (default: -fulfillment_date)
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public teacherTargetCreate(body: TeacherTargetCreate, observe?: 'body', reportProgress?: boolean): Observable<TeacherTarget>;
    public teacherTargetCreate(body: TeacherTargetCreate, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TeacherTarget>>;
    public teacherTargetCreate(body: TeacherTargetCreate, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TeacherTarget>>;
    public teacherTargetCreate(body: TeacherTargetCreate, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling teacherTargetCreate.');
        }

        let headers = this.defaultHeaders;

        // authentication (isophi-token-auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<TeacherTarget>('post',`${this.basePath}/teacher-target/`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Ordering options: fulfillment_date, created, modified (default: -fulfillment_date)
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public teacherTargetDestroy(id: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public teacherTargetDestroy(id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public teacherTargetDestroy(id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public teacherTargetDestroy(id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling teacherTargetDestroy.');
        }

        let headers = this.defaultHeaders;

        // authentication (isophi-token-auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/teacher-target/${encodeURIComponent(String(id))}/`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Ordering options: fulfillment_date, created, modified (default: -fulfillment_date)
     * @param fulfillmentDate 
     * @param fulfillmentDateGte 
     * @param fulfillmentDateLte 
     * @param limit Number of results to return per page.
     * @param offset The initial index from which to return the results.
     * @param ordering Which field to use when ordering the results.
     * @param recordType * &#x60;private&#x60; - Soukromý * &#x60;shared&#x60; - Sdílený
     * @param search A search term.
     * @param state V jakém stavu se cíl aktuálně nachází.  * &#x60;waiting&#x60; - Čeká * &#x60;in_process&#x60; - Probíhá * &#x60;finished&#x60; - Dokončeno * &#x60;incomplete&#x60; - Nedokončeno
     * @param supportType Jaká forma podpory je k naplnění cíle potřeba.  * &#x60;financial&#x60; - Finance * &#x60;material&#x60; - Materiál * &#x60;organizational&#x60; - Organizační
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public teacherTargetList(fulfillmentDate?: string, fulfillmentDateGte?: string, fulfillmentDateLte?: string, limit?: number, offset?: number, ordering?: string, recordType?: string, search?: string, state?: string, supportType?: string, observe?: 'body', reportProgress?: boolean): Observable<PaginatedTeacherTargetList>;
    public teacherTargetList(fulfillmentDate?: string, fulfillmentDateGte?: string, fulfillmentDateLte?: string, limit?: number, offset?: number, ordering?: string, recordType?: string, search?: string, state?: string, supportType?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PaginatedTeacherTargetList>>;
    public teacherTargetList(fulfillmentDate?: string, fulfillmentDateGte?: string, fulfillmentDateLte?: string, limit?: number, offset?: number, ordering?: string, recordType?: string, search?: string, state?: string, supportType?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PaginatedTeacherTargetList>>;
    public teacherTargetList(fulfillmentDate?: string, fulfillmentDateGte?: string, fulfillmentDateLte?: string, limit?: number, offset?: number, ordering?: string, recordType?: string, search?: string, state?: string, supportType?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {











        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (fulfillmentDate !== undefined && fulfillmentDate !== null) {
            queryParameters = queryParameters.set('fulfillment_date', <any>fulfillmentDate);
        }
        if (fulfillmentDateGte !== undefined && fulfillmentDateGte !== null) {
            queryParameters = queryParameters.set('fulfillment_date__gte', <any>fulfillmentDateGte);
        }
        if (fulfillmentDateLte !== undefined && fulfillmentDateLte !== null) {
            queryParameters = queryParameters.set('fulfillment_date__lte', <any>fulfillmentDateLte);
        }
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }
        if (offset !== undefined && offset !== null) {
            queryParameters = queryParameters.set('offset', <any>offset);
        }
        if (ordering !== undefined && ordering !== null) {
            queryParameters = queryParameters.set('ordering', <any>ordering);
        }
        if (recordType !== undefined && recordType !== null) {
            queryParameters = queryParameters.set('record_type', <any>recordType);
        }
        if (search !== undefined && search !== null) {
            queryParameters = queryParameters.set('search', <any>search);
        }
        if (state !== undefined && state !== null) {
            queryParameters = queryParameters.set('state', <any>state);
        }
        if (supportType !== undefined && supportType !== null) {
            queryParameters = queryParameters.set('support_type', <any>supportType);
        }

        let headers = this.defaultHeaders;

        // authentication (isophi-token-auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<PaginatedTeacherTargetList>('get',`${this.basePath}/teacher-target/`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Ordering options: fulfillment_date, created, modified (default: -fulfillment_date)
     * @param id 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public teacherTargetPartialUpdate(id: string, body?: PatchedTeacherTarget, observe?: 'body', reportProgress?: boolean): Observable<TeacherTarget>;
    public teacherTargetPartialUpdate(id: string, body?: PatchedTeacherTarget, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TeacherTarget>>;
    public teacherTargetPartialUpdate(id: string, body?: PatchedTeacherTarget, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TeacherTarget>>;
    public teacherTargetPartialUpdate(id: string, body?: PatchedTeacherTarget, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling teacherTargetPartialUpdate.');
        }


        let headers = this.defaultHeaders;

        // authentication (isophi-token-auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<TeacherTarget>('patch',`${this.basePath}/teacher-target/${encodeURIComponent(String(id))}/`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Ordering options: fulfillment_date, created, modified (default: -fulfillment_date)
     * @param fulfillmentDate 
     * @param fulfillmentDateGte 
     * @param fulfillmentDateLte 
     * @param ordering Which field to use when ordering the results.
     * @param recordType * &#x60;private&#x60; - Soukromý * &#x60;shared&#x60; - Sdílený
     * @param search A search term.
     * @param state V jakém stavu se cíl aktuálně nachází.  * &#x60;waiting&#x60; - Čeká * &#x60;in_process&#x60; - Probíhá * &#x60;finished&#x60; - Dokončeno * &#x60;incomplete&#x60; - Nedokončeno
     * @param supportType Jaká forma podpory je k naplnění cíle potřeba.  * &#x60;financial&#x60; - Finance * &#x60;material&#x60; - Materiál * &#x60;organizational&#x60; - Organizační
     * @param type Export type: &#x27;csv&#x27; or &#x27;xlsx&#x27;
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public teacherTargetPrintRetrieve(fulfillmentDate?: string, fulfillmentDateGte?: string, fulfillmentDateLte?: string, ordering?: string, recordType?: string, search?: string, state?: string, supportType?: string, type?: string, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public teacherTargetPrintRetrieve(fulfillmentDate?: string, fulfillmentDateGte?: string, fulfillmentDateLte?: string, ordering?: string, recordType?: string, search?: string, state?: string, supportType?: string, type?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public teacherTargetPrintRetrieve(fulfillmentDate?: string, fulfillmentDateGte?: string, fulfillmentDateLte?: string, ordering?: string, recordType?: string, search?: string, state?: string, supportType?: string, type?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public teacherTargetPrintRetrieve(fulfillmentDate?: string, fulfillmentDateGte?: string, fulfillmentDateLte?: string, ordering?: string, recordType?: string, search?: string, state?: string, supportType?: string, type?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {










        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (fulfillmentDate !== undefined && fulfillmentDate !== null) {
            queryParameters = queryParameters.set('fulfillment_date', <any>fulfillmentDate);
        }
        if (fulfillmentDateGte !== undefined && fulfillmentDateGte !== null) {
            queryParameters = queryParameters.set('fulfillment_date__gte', <any>fulfillmentDateGte);
        }
        if (fulfillmentDateLte !== undefined && fulfillmentDateLte !== null) {
            queryParameters = queryParameters.set('fulfillment_date__lte', <any>fulfillmentDateLte);
        }
        if (ordering !== undefined && ordering !== null) {
            queryParameters = queryParameters.set('ordering', <any>ordering);
        }
        if (recordType !== undefined && recordType !== null) {
            queryParameters = queryParameters.set('record_type', <any>recordType);
        }
        if (search !== undefined && search !== null) {
            queryParameters = queryParameters.set('search', <any>search);
        }
        if (state !== undefined && state !== null) {
            queryParameters = queryParameters.set('state', <any>state);
        }
        if (supportType !== undefined && supportType !== null) {
            queryParameters = queryParameters.set('support_type', <any>supportType);
        }
        if (type !== undefined && type !== null) {
            queryParameters = queryParameters.set('type', <any>type);
        }

        let headers = this.defaultHeaders;

        // authentication (isophi-token-auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request('get',`${this.basePath}/teacher-target/print/`,
            {
                params: queryParameters,
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Ordering options: fulfillment_date, created, modified (default: -fulfillment_date)
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public teacherTargetRetrieve(id: string, observe?: 'body', reportProgress?: boolean): Observable<TeacherTarget>;
    public teacherTargetRetrieve(id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TeacherTarget>>;
    public teacherTargetRetrieve(id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TeacherTarget>>;
    public teacherTargetRetrieve(id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling teacherTargetRetrieve.');
        }

        let headers = this.defaultHeaders;

        // authentication (isophi-token-auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<TeacherTarget>('get',`${this.basePath}/teacher-target/${encodeURIComponent(String(id))}/`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Ordering options: fulfillment_date, created, modified (default: -fulfillment_date)
     * @param body 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public teacherTargetUpdate(body: TeacherTargetUpdate, id: string, observe?: 'body', reportProgress?: boolean): Observable<TeacherTarget>;
    public teacherTargetUpdate(body: TeacherTargetUpdate, id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TeacherTarget>>;
    public teacherTargetUpdate(body: TeacherTargetUpdate, id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TeacherTarget>>;
    public teacherTargetUpdate(body: TeacherTargetUpdate, id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling teacherTargetUpdate.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling teacherTargetUpdate.');
        }

        let headers = this.defaultHeaders;

        // authentication (isophi-token-auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<TeacherTarget>('put',`${this.basePath}/teacher-target/${encodeURIComponent(String(id))}/`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
